
export enum TSR_TYPE {
    SESSION_TIMER,
    GAME_TIMER
}

